import 'swiper/css'
import 'swiper/css/navigation'

import React from 'react'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { IMapObject } from '@/core/interface'

type Props = {
  mode: 'low' | 'middle' | 'high'
  data: IMapObject | null
  openFullViewImage: () => void
  onPreviewClick: () => void
}

export function InfoWindowGallerySection(props: Props) {
  const { mode, data, openFullViewImage, onPreviewClick } = props

  if (mode === 'low' || data === null) return null

  if (data.gallery?.length === 0) {
    return (
      <img
        className="object__photo"
        src={data?.preview?.source}
        alt=""
        onClick={openFullViewImage}
      />
    )
  }

  if (data?.gallery !== undefined && data.gallery?.length > 0) {
    const gallery = data.gallery

    return (
      <div className="swiper-container-gallery">
        <Swiper
          spaceBetween={50}
          slidesPerView={1}
          modules={[Navigation]}
          navigation={{
            prevEl: `.swiper-button-prev`,
            nextEl: `.swiper-button-next`,
          }}
        >
          {gallery.map((point, index) => (
            <SwiperSlide key={index}>
              <div>
                <div className="object__photo__wrapper">
                  <img
                    onClick={onPreviewClick}
                    className="object__photo__swiper preview__mode"
                    src={point.uri}
                    alt={point.caption}
                    style={{
                      width: '100%',
                      objectFit: 'cover', // обрезает лишнее
                    }}
                  />
                  {point?.caption ? <p className="object__photo__caption">{point.caption}</p> : null}
                </div>
                {point?.copyright ? <p className="object__photo__copyright">{point.copyright}</p> : null}
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-prev`} />
          <div className={`swiper-button-next`} />
        </Swiper>
      </div>
    )
  }

  return null
}
